import React from "react";
import { Link } from "react-router-dom";
import { Card, Grid } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { baseUrl } from "../../axios";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import CustomProgressBar from "../customProgressBar/CustomProgressBar.jsx";
export default function Announcements(props) {
  const { data, loading, lastElement } = props;

  function handleProgress(array) {
    let compoletedAmount = 0;
    let onProgressAmount = 0;
    array.forEach((item) => {
      if (item.status === 3) {
        compoletedAmount += item.amount;
      }
      if (item.status === 2) {
        onProgressAmount += item.amount;
      }
    });

    return { compoletedAmount, onProgressAmount };
  }

  function handleAmount(array) {
    let amount = 0;
    array.forEach((item) => {
      if (item.status === 3) {
        amount += item.amount;
      }
    });
    return amount;
  }

  return (
    <div className="container mx-auto p-2">
    <div>
      <Grid container spacing={2}>
        {[...new Set(data)]?.map((item, index) => {
          if (data.length === index + 1) {
            return (
              <Grid ref={lastElement} item xs={6} md={6} key={item?.id}>
                <Link to={`/announcement/${item.id}`}>
                  <Card sx={{ maxWidth: 345 }}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        // height="140"
                        image={
                          item.image_src
                            ? `${baseUrl}files/${item?.image_src}`
                            : "./images/mosque-contruction.jpg"
                        }
                        alt="an image of announcement"
                        style={{ objectFit: "cover", maxHeight: "140px" }}
                      />
                      <CardContent>
                        <Typography
                          sx={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                          gutterBottom
                          component="div">
                          {item?.name}
                        </Typography>
                        <Typography
                          sx={{
                            marginBottom: "3px",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            display: "flex",
                          }}
                          variant="body2"
                          color="#1976D2">
                          <img
                            src="../../images/icon-location-2.svg"
                            alt="a location icon"
                            className="mr-1"
                          />
                          {item?.mosque?.name}
                        </Typography>
                        <CustomProgressBar
                          completed={
                            handleProgress(item.requests).compoletedAmount
                          }
                          inProgress={
                            handleProgress(item.requests).onProgressAmount
                          }
                          total={item?.amount}
                        />
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ color: "#404040" }}>
                          {handleAmount(item?.requests) | 0}/{item?.amount}
                          {` ${item?.amount_type} ${item?.category?.name}`}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
            );
          } else {
            return (
              <Grid item xs={6} md={6} key={item?.id}>
                <Link to={`/announcement/${item.id}`}>
                  <Card sx={{ maxWidth: 345 }}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        // height="140"
                        image={
                          item.image_src
                            ? `${baseUrl}files/${item?.image_src}`
                            : "./images/mosque-contruction.jpg"
                        }
                        alt="an image of announcement"
                        style={{ objectFit: "cover", maxHeight: "140px" }}
                      />
                      <CardContent>
                        <Typography
                          sx={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                          gutterBottom
                          component="div">
                          {item?.name}
                        </Typography>
                        <Typography
                          sx={{
                            marginBottom: "3px",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            display: "flex",
                          }}
                          variant="body2"
                          color="#1976D2">
                          <img
                            src="../../images/icon-location-2.svg"
                            alt="a location icon"
                            className="mr-1"
                          />
                          {item?.mosque?.name}
                        </Typography>
                        <CustomProgressBar
                          completed={
                            handleProgress(item.requests).compoletedAmount
                          }
                          inProgress={
                            handleProgress(item.requests).onProgressAmount
                          }
                          total={item?.amount}
                        />
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ color: "#404040" }}>
                          {handleAmount(item?.requests) | 0}/{item?.amount}
                          {` ${item?.amount_type} ${item?.category?.name}`}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
            );
          }
        })}
      </Grid>

      {loading && (
        <div className="min-h-[100px] flex justify-center items-center">
          <Box sx={{ display: "flex" }}>
            <CircularProgress />
          </Box>
        </div>
      )}
    </div>
  </div>
  );
}
